import auth from '@/router/auth'
import LogIndex from '@/components/logs/Index'
import LogCreate from '@/components/logs/Create'
import LogUpdate from '@/components/logs/Update'
import LogShow from '@/components/logs/Show'

export default [
  {
    path: '/logs',
    name: 'logs-index',
    component: LogIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/logs/create',
    name: 'logs-create',
    component: LogCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/logs/update/:course_id',
    name: 'logs-update',
    component: LogUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/logs/show/:course_id',
    name: 'logs-show',
    component: LogShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/logs/router.js